const moment = require("moment");

export const default_epp = () => {
    return {
        id: null,
        code: null,
        name: null,
        description: null,
        sys_list_type_id: null,
    };
};

export const default_worker = () => {
    return {
        id: null,
        identification: null,
        names: null,
        surnames: null,
        birthdate: null,
        gender_id: null,
        sys_list_identification_type_id: null,
        position: {
            start_date: moment().format("YYYY-MM-DD"),
            wor_position_id: null,
        },
        email: null,
        country_phone_code: null,
        phone: null,
        slq_location_id: null,
    };
};
export const default_worker_position = () => {
    return {
        id: null,
        start_date: moment().format("YYYY-MM-DD"),
        wor_position_id: null,
        wor_worker_id: null,
        finish_date: null,
        slq_location_id: null,
    };
};
export const default_worker_group_epp = () => {
    return {
        id: null,
        date: moment().format("YYYY-MM-DD"),
        wor_epp_id: null,
        wor_worker_id: null,
        epps: [],
    };
};

export const default_worker_epp = () => {
    return {
        id: null,
        wor_epp: {},
        wor_worker_group_epp_id: null,
        date: moment().format("YYYY-MM-DD"),
        result: null,
        wor_worker_epp_fit_tests: [],
    };
};

export const default_worker_epp_fit_test = () => {
    return {
        id: null,
        wor_worker_epp_id: null,
        date: moment().format("YYYY-MM-DD"),
        result: null,
    };
};
export const default_worker_training = () => {
    return {
        id: null,
        wor_worker_id: null,
        wor_training_id: null,
        topics: null,
        certificate: null,
        wor_training: {},
    };
};
export const default_worker_exam = () => {
    return {
        id: null,
        date: moment().format("YYYY-MM-DD"),
        main_findings: null,
        exams: [],
    };
};
export const default_params = () => {
    return {
        company_id: null,
        filter: null,
        wor_worker_id: null,
        wor_position_id: null,
        paginate: 1,
        page: 1,
        per_page: 10,
    };
};

export default {
    companies: [],
    areas: [],
    positions: [],
    position: [],
    epps: [],
    trainings: [],
    worker_positions: [],
    worker_groups_epps: [],
    worker_trainings: [],
    position_epps: [],
    worker_epps: [],
    worker_fit_epps: [],
    worker_group_exam: [],
    worker_exam_edit: [],
    worker_exams: [],
    workers: {
        data: [],
    },
    types: [],
    types_epp: [],
    exams: [],
    modal: { show: false },
    modal_upload: { show: false },
    modal_position: { show: false },
    modal_training: { show: false },
    modal_group_epp: { show: false },
    modal_worker_epp: { show: false },
    modal_worker_epp_fit_test: { show: false },
    modal_edit_epp: { show: false },
    modal_edit_exam: { show: false },
    modal_exam: { show: false },
    worker_epp: default_worker_epp(),
    worker: default_worker(),
    params: default_params(),
    worker_position: default_worker_position(),
    worker_group_epp: default_worker_group_epp(),
    worker_epp_fit_test: default_worker_epp_fit_test(),
    worker_training: default_worker_training(),
    worker_exam: default_worker_exam(),
    epp: default_epp(),
    editing: false,
    editing_position: false,
    editing_epp: false,
    editing_group_epp: false,
    editing_training: false,
    editing_worker_epp_fit_test: false,
    editing_fit_epp: false,
    editing_exam: false,
    editing_exam_edit: false,
    upload: {
        file: null,
    },
    current_slq_location_id: null,
};
